import React, { useState, useEffect } from "react";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import {
  isDashboardPathAllowed,
  getDefaultDashboardPath,
} from "../../utils/adminAccess";
import DashboardSidebar from "../DashboardSidebar/DashboardSidebar";
import DashboardHeader from "../DashboardHeader/DashboardHeader";
import { DashboardNotificationsProvider } from "../../contexts/DashboardNotificationsContext";
import Login from "../../pages/dashboard/login/login";
import "./DashboardLayout.css";

const isLoginPath = (path) =>
  path === "/dashboard/login" ||
  path === "/dashboard/login/forget-password" ||
  path === "/dashboard/login/reset-password";

function DashboardLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const isDashboardPage = location.pathname.startsWith("/dashboard");
  const token =
    localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
  const isLoggedIn = Boolean(token && token.trim() !== "");
  const needsLogin = !isLoggedIn && !isLoginPath(location.pathname);
  const showDashboardChrome = isLoggedIn && !isLoginPath(location.pathname);
  const pathAllowed =
    !isLoggedIn || isLoginPath(location.pathname) || isDashboardPathAllowed(location.pathname);

  useEffect(() => {
    if (isLoggedIn && !isLoginPath(location.pathname) && !pathAllowed) {
      // eslint-disable-next-line no-console
      console.warn("Redirecting restricted admin to store products.");
    }
  }, [isLoggedIn, location.pathname, pathAllowed]);

  if (isLoggedIn && !isLoginPath(location.pathname) && !pathAllowed) {
    return <Navigate to={getDefaultDashboardPath()} replace />;
  }

  return (
    <div
      className={`dashboard-container ${isDashboardPage ? "dashboard" : ""}`}
    >
      {isDashboardPage && (
        <DashboardNotificationsProvider>
          {showDashboardChrome && (
            <DashboardHeader toggleSidebar={() => setIsSidebarOpen(true)} />
          )}
          <div
            className={`dashboard-content ${
              !showDashboardChrome ? "dashboard-content-login-only" : ""
            }`}
          >
            {showDashboardChrome && (
              <DashboardSidebar
                isOpen={isSidebarOpen}
                closeSidebar={() => setIsSidebarOpen(false)}
              />
            )}
            <div
              className={`content-area ${
                isSidebarOpen ? "overlay-active" : ""
              }`}
            >
              {isSidebarOpen && (
                <div
                  className="overlay"
                  onClick={() => setIsSidebarOpen(false)}
                ></div>
              )}
              {needsLogin ? <Login /> : <Outlet />}
            </div>
          </div>
        </DashboardNotificationsProvider>
      )}
    </div>
  );
}

export default DashboardLayout;
